import { valueToBigNumber, valueToZDBigNumber } from '../../bignumber';
export function calculateUserReserveTotals({ userReserves, userERC1155Reserves }) {
    let totalLiquidityMarketReferenceCurrency = valueToZDBigNumber('0');
    let totalCollateralMarketReferenceCurrency = valueToZDBigNumber('0');
    let totalBorrowsMarketReferenceCurrency = valueToZDBigNumber('0');
    let currentLtv = valueToBigNumber('0');
    let currentLiquidationThreshold = valueToBigNumber('0');
    userReserves.forEach(userReserveSummary => {
        totalLiquidityMarketReferenceCurrency =
            totalLiquidityMarketReferenceCurrency.plus(userReserveSummary.underlyingBalanceMarketReferenceCurrency);
        totalBorrowsMarketReferenceCurrency = totalBorrowsMarketReferenceCurrency
            .plus(userReserveSummary.variableBorrowsMarketReferenceCurrency);
        if (userReserveSummary.userReserve.reserve.reserveLiquidationThreshold !==
            '0' &&
            userReserveSummary.userReserve.usageAsCollateralEnabledOnUser) {
            totalCollateralMarketReferenceCurrency =
                totalCollateralMarketReferenceCurrency.plus(userReserveSummary.underlyingBalanceMarketReferenceCurrency);
            currentLtv = currentLtv.plus(valueToBigNumber(userReserveSummary.underlyingBalanceMarketReferenceCurrency).multipliedBy(userReserveSummary.userReserve.reserve.baseLTVasCollateral));
            currentLiquidationThreshold = currentLiquidationThreshold.plus(valueToBigNumber(userReserveSummary.underlyingBalanceMarketReferenceCurrency).multipliedBy(userReserveSummary.userReserve.reserve.reserveLiquidationThreshold));
        }
    });
    userERC1155Reserves.forEach(userERC1155Reserve => {
        totalLiquidityMarketReferenceCurrency =
            totalLiquidityMarketReferenceCurrency.plus(userERC1155Reserve.usdValue);
        if (userERC1155Reserve.liquidationThreshold !== '0') {
            totalCollateralMarketReferenceCurrency =
                totalCollateralMarketReferenceCurrency.plus(userERC1155Reserve.usdValue);
            currentLtv = currentLtv.plus(valueToBigNumber(userERC1155Reserve.usdValue).multipliedBy(userERC1155Reserve.ltv));
            currentLiquidationThreshold = currentLiquidationThreshold.plus(valueToBigNumber(userERC1155Reserve.usdValue).multipliedBy(userERC1155Reserve.liquidationThreshold));
        }
    });
    if (currentLtv.gt(0)) {
        currentLtv = valueToZDBigNumber(currentLtv.div(totalCollateralMarketReferenceCurrency));
    }
    if (currentLiquidationThreshold.gt(0)) {
        currentLiquidationThreshold = valueToZDBigNumber(currentLiquidationThreshold.div(totalCollateralMarketReferenceCurrency));
    }
    return {
        totalLiquidityMarketReferenceCurrency,
        totalBorrowsMarketReferenceCurrency,
        totalCollateralMarketReferenceCurrency,
        currentLtv,
        currentLiquidationThreshold,
    };
}
//# sourceMappingURL=calculate-user-reserve-totals.js.map